<template>
  <div id="tryout-list-component">
    <v-snackbar
      v-model="toast"
      :timeout="3000"
      color="black"
      dark
    >
      Gagal mengambil soal
    </v-snackbar>
    <div class="loader" v-if="loader">
        <v-progress-circular
        :size="70"
        :width="7"
        color="white"
        indeterminate
      ></v-progress-circular>
      </div>
    <v-container class="tryout-list">
        <!-- {{list}} -->
      <div v-for="(item,index) in list.tryouts" v-bind:key="index" @click="item.state === 'FINISHED' || item.state === 'GRADED' ? '' : toDetail(item)">
        <!-- v-if="item.state !== null && list.state === 'JOINED' || item.state === null && list.state === null" -->
        <v-card class="to" v-if="item.state !== null || item.state === null && list.state === null">
          <div class="freetag" v-if="false">
            <img alt="image-alt" src="@/assets/icon/ic_freetag.svg"/>
            <span>Gratis</span>
          </div>
          <v-layout>
            <v-flex xs12>
              <span v-if="$route.name !== 'tryout-list' && $route.name !== 'instant-list'">
                <v-btn color="#69F0AE" depressed small dark round v-if="item.type === 'SBMPTN'">SNBT</v-btn>
                <v-btn color="#D69FFA" depressed small dark round v-else-if="item.type === 'UJIAN_AKHIR_NASIONAL' || item.type === 'UJIAN_NASIONAL'">UN</v-btn>
                <v-btn color="#FFB74D" depressed small dark round v-else-if="item.type === 'UJIAN_AKHIR_SEKOLAH'">UAS</v-btn>
                <v-btn color="#FFD755" depressed small dark round v-else-if="item.type === 'PENILAIAN_TENGAH_SEMESTER'">PTS</v-btn>
                <v-btn color="#FF9797" depressed small dark round v-else-if="item.type === 'PENILAIAN_AKHIR_SEMESTER'">PAS</v-btn>
                <v-btn color="#81D4FA" depressed small dark round v-else-if="item.type === 'UJIAN_SEKOLAH'">US</v-btn>
                <v-btn color="#1e88e5" depressed small dark round v-else-if="item.type === 'UJIAN_MANDIRI'">MANDIRI</v-btn>
              </span>
              <span v-if="$route.name === 'tryout-list' || $route.name === 'instant-list'" style="padding-left:15px; font-size:14px;">
                <b style="color:#10AA85" v-if="item.category === 'TPS'">TPS</b>
                <b style="color:#AD7ACF" v-if="item.category === 'SAINTEK'">SAINTEK</b>
                <b style="color:#EB5757" v-if="item.category === 'SOSHUM'">SOSHUM</b>
                <b style="color:#00ADE2;" v-if="item.category === 'LITERASI'">LITERASI</b>
                <b style="color:#00ADE2;" v-if="item.category === 'OTHER'">OTHER</b>
              </span>
            </v-flex>
          </v-layout>
            <v-card-text class="act-6" style="padding-left:15px;">
              <h2 style="line-height:1.5rem;color:#494949;">{{ item.name }}</h2>
            </v-card-text>
            
            <v-card-actions class="act-5">
              <p id="ic-actions-bb" v-if="$route.name === 'tryout-group'">
              <img
                src="@/assets/icon/result/ic_tanggal.svg"
                alt="image-alt"
                style="width: 20px; margin-right: 4px;"
              />
              &nbsp; {{ item.opened_at | moment("DD MMMM") }} - {{ item.closed_at | moment("DD MMMM YYYY") }} </p>
              
              <p id="ic-actions-bb" v-if="$route.name === 'tryout-list' || $route.name === 'tryout-list-serial'">
              <img
                src="@/assets/icon/result/ic_tanggal.svg"
                alt="image-alt"
                style="width: 20px; margin-right: 4px;"
              />
              Mulai {{ item.start_date + ' ' + item.start_time  | moment("DD MMMM YYYY HH:mm") }}</p>
            </v-card-actions>
            <v-card-actions class="act-4">
              <p id="ic-actions-bb" v-if="$route.name === 'tryout-list' || $route.name === 'tryout-list-serial'">
              <img
                src="@/assets/icon/result/ic_tanggal.svg"
                alt="image-alt"
                style="width: 20px; margin-right: 4px;"
              />
               Selesai {{ item.end_date + ' ' + item.end_time | moment("DD MMMM YYYY HH:mm") }}</p>
            </v-card-actions>
            <v-card-actions class="act-3">
            <span id="ic-actions-bb" v-if="$route.name === 'instant-list' || $route.name === 'tryout-list' || $route.name === 'tryout-list-serial'">
              <img
                src="@/assets/icon/ic_durasi.svg"
                alt="image-alt"
                style="width: 20px; margin-right: 4px;"
              />
              {{ item.duration + ' menit'}}</span>
              <span id="ic-actions-bb" v-if="$route.name === 'tryout-group'">
              <img
                src="@/assets/icon/result/ic_soal.svg"
                alt="image-alt"
                style="width: 20px; margin-right: 4px;"
              />
               {{ item | countingSoal}} Soal</span>
              <span id="ic-actions-bb" v-if="$route.name === 'instant-list'">
              <img
                src="@/assets/icon/result/ic_soal.svg"
                alt="image-alt"
                style="width: 20px; margin-right: 4px;"
              />
               {{ item | countingSoalInstant}} Soal</span>
              <span id="ic-actions-bb" v-if="$route.name === 'tryout-list' || $route.name === 'tryout-list-serial'">
              <img
                src="@/assets/icon/result/ic_soal.svg"
                alt="image-alt"
                style="width: 20px; margin-right: 4px;"
              />
              {{ item | countingSubtes}} Soal</span>
              
            </v-card-actions>
            <v-card-actions :class="$route.name === 'tryout-list' && item.state === null? 'act-2' : 'act-1'" v-if="$route.name === 'instant-list' || $route.name === 'tryout-list' || $route.name === 'tryout-list-serial' && list.state !== null">
              <div style="display:flex; align-items:center; margin:15px;" v-if="item.state === 'JOINED' && showCountDown(item.start_date + ' ' + item.start_time, index)">Dimulai dalam: <h2 style="color:#10aa85; padding-left:15px;" id="timer-countdown">{{ startTime(item.start_date + ' ' + item.start_time, index)}}</h2></div>
              <v-btn color="#10aa85" v-if="item.state === 'JOINED' && !showCountDown(item.start_date + ' ' + item.start_time, index)" style="margin:10px;" small dark round @click.stop="start(item)">MULAI</v-btn>
              <span v-if="item.state === 'STARTED'" class="orange--text" style="display:flex; align-items:center; margin:10px;font-size:16px;">
                <!-- <v-icon color="orange">autorenew</v-icon>&nbsp; -->
                BERLANGSUNG
              </span>
              <v-btn small v-if="item.state === 'FINISHED' || item.state === 'GRADED'" color="white" style="color: #40c24f; margin:10px;" round depressed>
                SELESAI
              </v-btn>
            </v-card-actions>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<style>
.loader {
  z-index: 999;
  position: fixed;
  min-height: 100vh;
  width:100%;
  max-width:480px;
  top:0;
  opacity: 0.5;
  background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
}
.details {
  padding:15px; padding-bottom: 0px;
}
.startdate {
  padding:15px;padding-top:0px; padding-bottom:0px;
}
.enddate {
  padding:15px;padding-top:0px; padding-bottom:20px;
}
.loading {
  padding: 20%;
  justify-content: center;
  display: flex;
}
.to{
    border-radius: 15px;
    padding-top: 15px;
    margin-bottom: 15px;
}
.v-card__actions {
  padding: 0;
}

.v-card-actions__group--custom {
  margin-right: 25px;
}

.v-card-actions__group--custom .v-icon {
  margin-right: 10px;
}

#ic-actions-bb {
  margin-right: 15px;
  margin-left: 15px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 11px;
}

.freetag {
  position: absolute;
  right: 0;
  top: -4px;
}

.freetag span{
  position: absolute;
  left: 8px;
  color: white;
}

.empty-state {
    display: flex;
    flex-wrap: wrap;
    flex-flow: column;
    justify-content: center;
    align-items: center;
}

#tryout-list-component {
  margin-bottom: 56px;
}

.act-1 {
  display:flex; justify-content: flex-end; padding: 10px; border-top: lightgray 1px solid; margin-bottom:10px;
  color:#9C9C9C;
}

.act-2 {
  display:flex; justify-content: flex-end; padding: 10px;
  color:#9C9C9C;
}

.act-3 {
  padding:15px;padding-top:0px; padding-bottom:20px; margin-bottom:10px;
  color:#9C9C9C;
}

.act-4 {
  padding:15px;padding-top:0px; padding-bottom:0px;
  color:#9C9C9C;
}


.act-5 {
  padding:15px; padding-bottom: 4px;
  margin-top:10px;
  color:#9C9C9C;
  color:#9C9C9C;
}

.act-6 {
  padding-bottom: 0px;
  color:#9C9C9C;
}
</style>

<script>
// import moment from 'moment/src/moment'
import moment from 'moment-timezone'
import TryoutResultStatusVue from './TryoutResultStatus.vue'
moment.tz.setDefault('Asia/Jakarta')
/* eslint-disable */
export default {
  name: 'tryout-list-component',
  props: {
    list: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      loading: true,
      today: new Date().getTime(),
      joined: false,
      loader: false,
      toast: false,
      // showCountDown: false
    }
  },
  filters: {
    countingSoal(value) {
      var total = 0
      if(value.tryouts.length > 0) {
        for(var i = 0; i < value.tryouts.length; i++) {
          var subtes = value.tryouts[i].subtests
          if(subtes.length > 0){
            for (var a = 0; a < subtes.length; a++) {
              total += subtes[a].item_count
            }
          } else {
            return 0
          }
        }
        return total
      } else {
        return 0
      }
    },
    countingSoalInstant (value) {
      var total = 0
      // if(value.tryouts.length > 0) {
        // for(var i = 0; i < value.tryouts.length; i++) {
          var subtes = value.subtests
          if(subtes.length > 0){
            for (var a = 0; a < subtes.length; a++) {
              total += subtes[a].item_count
            }
          } else {
            return 0
          }
        // }
        return total
      // } else {
      //   return 0
      // }
    },
    countingSubtes (value) {
      var total = 0
      var subtes = value.subtests
        if(subtes.length > 0){
          for (var a = 0; a < subtes.length; a++) {
            total += subtes[a].item_count
          }
          return total 
        } else {
          return 0
        }
    },
    timeConvert (n) {
      var num = n;
      var hours = (num / 60);
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      if (num < 60) {
        return num + ' menit';
      }else if(rminutes > 0) {
        return rhours + " jam " + rminutes + " menit";
      } else if (rminutes == 0 && rhours == 1) {
        return num + " menit";
      } else {
        return rhours + " jam";
      } 
    }
  },
  methods: {
    toDetail (index) {
      if (this.$route.name === 'tryout-group') {
        this.$router.push('/tryout/'+ index.id)
      } else if (this.$route.name === 'tryout-list'  && index.state === null) {
        // this.$router.push('/tryout/'+ this.list.id + '/detail/' + index.id)
        // this.$emit('clicks', '')
      } else if (this.$route.name === 'tryout-list-serial' && index.state === null){
        this.$router.push('/serial/'+ this.$route.params.id + '/detail/' + this.list.id + '/' + index.id)
      } else {
        this.$store.commit('setAllClose')
        var dateA = moment(index.start_date + ' ' + index.start_time)
        var a = moment(dateA, 'YYYY-MM-DD HH:mm:ss').format('x')
        var b = moment(this.$store.state.tryout.serverTime).format('x')
        if (b < a && this.$route.name !== 'instant-list') {
          // this.$store.commit('setCountdown', [dateA._i, index])
        } else {
          if(this.$route.name === 'tryout-list-serial'){
            this.$router.push('/tryout-serial/'+ this.list.id + '/mata-pelajaran/' + index.id)
          } else {
            // this.$router.push('/tryout/'+ this.list.id + '/mata-pelajaran/' + index.id)
            if(index.state === 'STARTED'){

              this.reConfigTryoutMechanism(index.id, this.list, this.$store.state.tryout.serverTime) //servertime
              
            } else {
              this.$store.commit('setStartConfirmation', index)
            }
          }
          
        }
      }
    },
    checkStat (item) {
      if(item.state !== null && this.today >= item.opened_at && this.today <= item.closed_at) return 'berlangsung'
      if(item.state === null) return 'subscribe'
      if(item.state !== null) return 'terdaftar'
    },
    register (value) {
      var user = JSON.parse(sessionStorage.profile)
      var scopes = JSON.parse(sessionStorage.scopes)
      var tryout = []
      var tryout_schedule = false
      for (var i = 0; i < scopes.length; i++) {
        if (scopes[i] === 'app_scheduled_tryout') {
          tryout_schedule = true
        }
      }
      // if (value) {
        // this.$store.dispatch('funcGetTryoutDetailV2Joined', parseInt(value.group_id)).then(response => {
          tryout = value
          this.$store.commit('setAllClose')
          // if (!tryout_schedule) this.$store.commit('setPremiumConfirmation', tryout)
          if (!tryout_schedule) return false
          else if ( user.is_nf_student && tryout.is_private ) this.$store.commit('setSubscribeCode', tryout)
          else this.checkType(tryout)
          // })
        
      // } else {
      //   tryout = value
      // }
      // this.$store.commit('setAllClose')
      // if (!tryout_schedule) this.$store.commit('setPremiumConfirmation', tryout)
      // else if ( user.is_nf_student && tryout.is_private ) this.$store.commit('setSubscribeCode', tryout)
      // else this.checkType(tryout)
    },
    checkType (tryout) {
      if( tryout.type === 'SBMPTN' ) this.$store.commit('setMajorSelect', tryout)
      else this.$store.commit('setSubscribeConfirmation', tryout)
    },
    start (item) {
      // console.log(item)
      this.$store.commit('setAllClose')
      var dateA = moment(item.start_date + ' ' + item.start_time)
      var a = moment(dateA, 'YYYY-MM-DD HH:mm:ss').format('x')
      var b = moment(this.$store.state.tryout.serverTime).format('x')
      if (b < a && this.$route.name !== 'instant-list') {
        // this.$store.commit('setCountdown', [dateA._i, item])
      } else {
        this.$store.commit('setStartConfirmation', item)
      }
    },
    reConfigTryoutMechanism(id, group, serverTime) {
      // console.log(group)
      this.loader = TryoutResultStatusVue
      if(this.$route.name === 'instant-list') {
        
        var context = this
        var tryoutGroup = {}
        var tryout = []
        
        // this.$store.dispatch('funcGetTryoutDetailV2Joined', id).then(response => {
          // tryoutGroup = response.data
          // tryout = response.data
        
          // var tryoutGroup = JSON.parse(sessionStorage.instantTestData)
          var tryout= JSON.parse(sessionStorage.instantTestData)
          // var tryout = tryoutGroup.tryouts.find(function (element) {
          //   return element.id === id
          // })
          var duration = tryout.tryouts.find(function (element) {
            return element.id === id
          })

          if(!localStorage.getItem('s-'+id + '-' + sessionStorage.UID)) {
            var statPengerjaan = []
            duration.subtests.forEach(element => {
              statPengerjaan.push({
                code: element.subtest_code,
                status: 'UNSTARTED'
              })
            });
            localStorage.setItem('s-' + id + '-' + sessionStorage.UID, JSON.stringify(statPengerjaan))
          }

          var o = {
            d: duration.duration,
            sd:  serverTime, //servertime
            type: duration.type,
            series: false
          }
          localStorage.setItem(id + '-' + sessionStorage.UID, JSON.stringify(o))
          this.loader = false
        // })
        var params = {
            code: duration.code,
            bundle: duration.bundle_code }
          var action_name = null
          if(this.$route.name === 'instant-list') action_name = 'funcGetQuestionInstantTest'
          else action_name = 'funcGetQuestion' 

          this.$store.dispatch(action_name, params).then(response => {
            this.loader = false
            if(this.$route.name !== 'instant-list') this.$router.push('/tryout/'+ group.id + '/mata-pelajaran/' + id)
            else this.$router.push('/instant/'+ duration.code + '/mata-pelajaran/' + id)
            // if(sessionStorage.getItem('realtimeMode') === 'false' && !localStorage.getItem(params.bundle + '-' + sessionStorage.UID)) this.$store.dispatch('funcGetAnswer', params)
          }).catch(err => {
            this.toast = true
            setTimeout(() => {
              this.loader = false
            }, 1000);
          })
      } else {
        var context = this
        var tryoutGroup = {}
        var tryout = []
        this.$store.dispatch('funcGetTryoutDetailV2Joined', group.id).then(response => {
          // console.log(response)
          tryoutGroup = response.data
          tryout = response.data
          var duration = tryout.tryouts.find(function (element) {
            return element.id === id
          })

          if(!localStorage.getItem('s-'+id + '-' + sessionStorage.UID)) {
            var statPengerjaan = []
            duration.subtests.forEach(element => {
              statPengerjaan.push({
                code: element.subtest_code,
                status: 'UNSTARTED'
              })
            });
            localStorage.setItem('s-' + id + '-' + sessionStorage.UID, JSON.stringify(statPengerjaan))
          }

          var o = {
            d: duration.duration,
            sd:  serverTime, //servertime
            type: duration.type,
            series: false
          }
          localStorage.setItem(id + '-' + sessionStorage.UID, JSON.stringify(o))
          var params = {
            code: duration.code,
            bundle: duration.bundle_code }
          var action_name = null
          if(this.$route.name === 'instant-list') action_name = 'funcGetQuestionInstantTest'
          else action_name = 'funcGetQuestion' 

          this.$store.dispatch(action_name, params).then(response => {
            this.loader = false
            if(this.$route.name !== 'instant-list') this.$router.push('/tryout/'+ group.id + '/mata-pelajaran/' + id)
            else this.$router.push('/instant/'+ group.code + '/mata-pelajaran/' + id)
            // if(sessionStorage.getItem('realtimeMode') === 'false' && !localStorage.getItem(params.bundle + '-' + sessionStorage.UID)) this.$store.dispatch('funcGetAnswer', params)
          }).catch(err => {
            this.toast = true
            setTimeout(() => {
              this.loader = false
            }, 1000);
          })
          // location.reload()
        })
      }
        
    },
    showCountDown(startTime, i){
      let epoch = moment(startTime, 'YYYY-MM-DD HH:mm:ss').format('x')
      let todays = this.$store.state.tryout.serverTime
      if(epoch > todays){ 
        return true
      } else { 
        return false 
      }
    },
    startTime(startTime, i){
      // console.log(startTime, i)
      let epoch = moment(startTime, 'YYYY-MM-DD HH:mm:ss').format('x')
      let todays = this.$store.state.tryout.serverTime
      if(epoch > todays){
        var countDownDate = epoch
        // Update the count down every 1 second
        // var x = setInterval(function() {

        //   // Get today's date and time
          var now = todays
            
          // Find the distance between now and the count down date
          var distance = countDownDate - now;
            
          // Time calculations for days, hours, minutes and seconds
          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            
          // Output the result in an element with id="demo"
          // console.log()

          if(days > 0) {
            return days + ' Hari'
          } else {
            let h = hours
            let m = minutes
            let s = seconds
            if (hours < 10) h = '0' + hours
            if (minutes < 10) m = '0' + minutes
            if (seconds < 10) s = '0' + seconds
            return h + ":"
            + m + ":" + s ;
          }
         
            
          // If the count down is over, write some text 
          // if (distance < 0) {
          //   clearInterval(x);
          //   document.getElementById("timer-countdown").innerHTML = "EXPIRED";
          // }
          
            
          // If the count down is over, write some text 
          
        // }, 1000);

        // return true
      }
      
      
      // return true
    }
  },
  mounted(){
      this.today = this.$store.state.tryout.serverTime //servertime
  }
}
</script>
